import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [{
    path: '/',
    name: 'index',
    component: () => import('../views/index.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login.vue')
  },
  {
    path: '/task_add',
    name: 'task_add',
    component: () => import('../views/task_add.vue')
  },
  {
    path: '/task_info',
    name: 'task_info',
    component: () => import('../views/task_info.vue')
  },
  {
    path: '/task_make',
    name: 'task_make',
    component: () => import('../views/task_make.vue')
  },
  {
    path: '/task_customer',
    name: 'task_customer',
    component: () => import('../views/task_customer.vue')
  },
  {
    path: '/device_set',
    name: 'device_set',
    component: () => import('../views/device_set.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  var uid = localStorage.getItem('uid');
  if (!uid) {
    if (to.path === '/login' || to.path=='/task_customer') { // 如果当前用户输入的是登录路由，那么就定向到 /choice_course 路由
      next()
    } else {
      next('/login');
    }
  } else {
    next()
  }
})

export default router